import React, { memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Group, Text } from '@mantine/core';
import QuestSingleChoice from './QuestSingleChoice';
import QuestMultipleChoice from './QuestMultipleChoice';
import QuestConfirmation from './QuestConfirmation';
import QuestInput from './QuestInput';
import QuestStart from './QuestStart';
import InteractionHistory from './InteractionHistory';
import DotLoader from '../../DotLoader/DotLoader';
import PersistentTextArea from './PersistentTextArea';
import { InteractionContainer, RestartButton } from './InteractionHandlerCSS';

// Composant pour l'interaction actuelle
const CurrentQuestion = memo(({ interaction }) => {
  if (!interaction) return null;

  switch (interaction.type) {
    case 'questSingleChoice':
      return <QuestSingleChoice />;
    case 'questMultChoice':
      return <QuestMultipleChoice />;
    case 'questConfirmation':
      return <QuestConfirmation />;
    case 'questInput':
      return <QuestInput />;
    case 'questStart':
      return <QuestStart />;
    default:
      return <div></div>;
  }
});

const InteractionHandler = () => {
  const currentInteraction = useSelector(
    (state) => state.interaction.currentInteraction
  );
  const interactionThread = useSelector(
    (state) => state.interaction.interactionThread
  );
  const isVisible = useSelector(
    (state) => state.interaction.interactionWindowVisible
  );

  const status = useSelector((state) => state.interaction.status);
  const server_action = useSelector(
    (state) => state.interaction.server_action || 'zzzzzz'
  );

  const dispatch = useDispatch();

  // Fonction pour démarrer une nouvelle conversation
  const startNewConversation = () => {
    // Réinitialise l'état de l'interaction et ouvre QuestStart
    dispatch({ type: 'INTERACTION_RESET' });
    dispatch({
      type: 'INTERACTION_START_NEW',
      payload: {
        type: 'questStart',
        data: {
          question: 'Comment puis-je vous aider ?',
          questionId: `new-${Date.now()}`,
          description:
            'Posez votre question ou décrivez ce que vous souhaitez faire',
        },
      },
    });
  };

  // Si rien n'est visible, ne rien rendre
  if (!isVisible && !interactionThread.length) return null;

  const shouldShowCurrentQuestion =
    isVisible && status === 'wait_user' && currentInteraction;
  const showRestartButton =
    interactionThread.length > 0 ||
    (status === 'wait_server' && !currentInteraction);

  return (
    <InteractionContainer>
      {/* Afficher l'historique des interactions */}
      {interactionThread.length > 0 && (
        <InteractionHistory thread={interactionThread} />
      )}

      {/* Afficher l'interaction courante */}
      {shouldShowCurrentQuestion && (
        <CurrentQuestion interaction={currentInteraction} />
      )}

      {status === 'wait_server' && (
        <div
          style={{
            padding: '10px',
            backgroundColor: '#f5f5f5',
            border: '1px solid #ddd',
            borderRadius: '4px',
            marginTop: '10px',
          }}
        >
          <Group direction="row">
            <DotLoader />
            <Text color="black">Server Action: {server_action}</Text>
          </Group>
        </div>
      )}
      {shouldShowCurrentQuestion &&
        currentInteraction.type !== 'questStart' && <PersistentTextArea />}
      {showRestartButton && (
        <RestartButton onClick={startNewConversation}>
          Nouvelle conversation
        </RestartButton>
      )}
    </InteractionContainer>
  );
};

export default InteractionHandler;
